import {Injectable} from '@angular/core';
import {AbstractProdSelectService, IProdSelectProperties} from 'prod-select';

@Injectable({
  providedIn: 'root'
})

export class FirmwareTypeService extends AbstractProdSelectService {
  override selectDataUrl: string = 'firmwareTypes';
  override selectProperties: IProdSelectProperties = {
    id: 'id',
    name: 'name'
  };
}
